// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__s-Kc+","large_btn":"Button_large_btn__VWC7b","small_btn":"Button_small_btn__t1xaD"};